import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../actions/userActions";
import MainScreen from "../../components/MainScreen";
import { useAuth } from "react-oidc-context";
import { demarrerDeconnexion, terminerDeconnexion } from "../../utils/logoutBroadcast";

function LogoutScreen({ history }) {
  const dispatch = useDispatch();

  const auth = useAuth();
  // Une seule tentative : le contexte oidc se met à jour plusieurs fois pendant la
  // déconnexion (activeNavigator puis USER_UNLOADED) et relancerait sinon signoutRedirect.
  const dejaTraite = useRef(false);

  useEffect(() => {
    if (auth.isLoading || dejaTraite.current) return;

    if (auth.isAuthenticated) {
      dejaTraite.current = true;
      // Poser le verrou AVANT de partir : pendant toute la navigation vers Keycloak, les
      // autres onglets ne doivent pas pouvoir recréer une session sur le cookie SSO encore
      // vivant (cf. utils/logoutBroadcast.js).
      demarrerDeconnexion();
      // Pas de removeUser() ici : signoutRedirect le fait lui-même. L'appeler en amont
      // faisait basculer isAuthenticated à false avant que la navigation ne parte, ce qui
      // déclenchait la branche de retour ci-dessous en pleine déconnexion.
      auth.signoutRedirect({ id_token_hint: auth.user.id_token }).catch((error) => {
        // Sans ce catch, l'échec part dans le handler global unhandledrejection d'App.js
        // (redirection /500) et la déconnexion Keycloak échouée passe inaperçue.
        console.error("Échec de la déconnexion Keycloak", error);
        terminerDeconnexion();
        dejaTraite.current = false;
      });
      return;
    }

    // Retour depuis Keycloak (post_logout_redirect_uri = /logout), ou arrivée alors qu'on
    // n'était déjà plus authentifié.
    dejaTraite.current = true;
    // Avec `auth` : clearStaleState purge les entrées oidc.<state> laissées dans
    // localStorage par chaque aller-retour.
    dispatch(logout(auth));
    terminerDeconnexion();
    history.replace('/');
  }, [auth.isLoading, auth.isAuthenticated]);

  return (
    <MainScreen title={auth.error && "Déconnexion"}>
        {auth.error && (<div>Une erreur est survenue... {auth.error.message}</div>)}
    </MainScreen>
  );
};
export default LogoutScreen;
